import React, { useEffect, useState } from "react";
import { Box, Grid } from "@mui/material";
import { connect, useSelector } from "react-redux";
import { mapVtrStateToProps } from "../../services/mapStateToProps";
import { mapDispatchToProps } from "../../constants/dispatchNewTripForm";
import DefaultButton from "../../components/DefaultButton";
import {
  getEffortGearCode,
  getEffortLatitude,
  getEffortLatLonFormat,
  getEffortLongitude,
  currentLocationHandler,
} from "../../constants/Effort";
import { Navigate, useLocation } from "react-router-dom";
import LatLongFormat from "../../components/LatLongFormat";
import DecimalDegrees from "../../components/DecimalDegrees";
import DegreesDecimalMinutes from "../../components/DegreesDecimalMinutes";
import DegreesMinutesSeconds from "../../components/DegreesMinutesSeconds";
import { validateEffortSet3 } from "../../constants/effortValidations";
import { latLongFormats } from "../../constants/LatLong";
import { getTripTripId } from "../../constants/vtrTrip";
import { success } from "../../constants/colors";

function EffortPage3(props) {
  const { actions } = props;
  const { auth, vtrTrip, helpText, validation } = useSelector((state) => state);
  const location = useLocation();
  // Regex allows digits, an optional single decimal point, and up to four digits after the decimal
  const regex = new RegExp(`^(-?)\\d+\\.\\d{5,}$`);

  const [values, setValues] = useState({
    lat_long_format: "",
    latitude_or_loran1: {
      decimal_degrees: "",
      degrees_decimal_minutes: { degrees: "", minutes: "" },
      degrees_minutes_seconds: { degrees: "", minutes: "", seconds: "" },
    },
    longitude_or_loran2: {
      decimal_degrees: "",
      degrees_decimal_minutes: { degrees: "", minutes: "" },
      degrees_minutes_seconds: { degrees: "", minutes: "", seconds: "" },
    },
    latLongFormats: latLongFormats,
    effortNr: null,
    trip_id: null,
  });

  useEffect(() => {
    let gearCode = getEffortGearCode(location.state);
    let currentGearState = {};
    currentGearState.gearcode = gearCode;
    currentGearState.latitude_or_loran1 = getEffortLatitude(location.state);
    currentGearState.longitude_or_loran2 = getEffortLongitude(location.state);
    currentGearState.lat_long_format = getEffortLatLonFormat(location.state);
    currentGearState.effortNr = location.state.effortNr;
    currentGearState.trip_id = getTripTripId(location.state);
    setValues({ ...values, ...currentGearState });
    if (vtrTrip.redirect) {
      actions.resetTripRedirect();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInputChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  const handleLatChange = function (event) {
    event.preventDefault();
    const { name, value } = event.target;
    const { lat_long_format } = values;

    setValues((prevValues) => {
      const newLatitude = { ...prevValues.latitude_or_loran1 };

      switch (lat_long_format) {
        case "Decimal Degrees":
          if (value === "" || !regex.test(value)) {
            newLatitude.decimal_degrees = value;
          }
          break;
        case "Degrees Decimal Minutes":
          newLatitude.degrees_decimal_minutes[name] = value;
          break;
        case "Degrees Minutes Seconds":
          newLatitude.degrees_minutes_seconds[name] = value;
          break;
        default:
          break;
      }
      return {
        ...prevValues,
        latitude_or_loran1: newLatitude,
      };
    });
  };

  const handleLonChange = function (event) {
    event.preventDefault();
    const { name, value } = event.target;
    const { lat_long_format } = values;

    setValues((prevValues) => {
      const newLongitude = { ...prevValues.longitude_or_loran2 };

      switch (lat_long_format) {
        case "Decimal Degrees":
          if (value === "" || !regex.test(value)) {
            newLongitude.decimal_degrees = value;
          }
          break;
        case "Degrees Decimal Minutes":
          newLongitude.degrees_decimal_minutes[name] = value;
          break;
        case "Degrees Minutes Seconds":
          newLongitude.degrees_minutes_seconds[name] = value;
          break;
        default:
          break;
      }
      return {
        ...prevValues,
        longitude_or_loran2: newLongitude,
      };
    });
  };

  const _cancel = (event, value) => {
    event.preventDefault();
    let errors = [];
    actions.setError(errors);
    if (value === "Cancel") {
      actions.setTripRedirect();
    }
  };

  const _next = (event, value) => {
    event.preventDefault();
    let allErrors = validateEffortSet3(values, validation.validations.gear);
    actions.setError(allErrors);

    if (allErrors.length > 0) {
      return;
    }
    if (value === "Save") {
      actions.updateEffort(values, auth.client_id);
    }
  };

  if (vtrTrip.redirect === true) {
    return (
      <Navigate
        replace
        to={`${process.env.PUBLIC_URL}/effort-review`}
        state={{
          trip_id: values.trip_id,
          client_id: auth.client_id,
          effortNr: values.effortNr,
        }}
      />
    );
  }

  return (
    <div className="margAll10">
      <LatLongFormat
        handleChange={handleInputChange}
        latLongFormats={values.latLongFormats}
        lat_long_format={values.lat_long_format}
        helpText={helpText.helpText}
        currentLocationHandler={currentLocationHandler(values, setValues)}
      />
      {
        {
          "Decimal Degrees": (
            <DecimalDegrees
              handleLatChange={handleLatChange}
              handleLonChange={handleLonChange}
              lat_long_format={values.lat_long_format}
              latitude_or_loran1={values.latitude_or_loran1}
              longitude_or_loran2={values.longitude_or_loran2}
            />
          ),
          "Degrees Decimal Minutes": (
            <DegreesDecimalMinutes
              handleLatChange={handleLatChange}
              handleLonChange={handleLonChange}
              lat_long_format={values.lat_long_format}
              latitude_or_loran1={values.latitude_or_loran1}
              longitude_or_loran2={values.longitude_or_loran2}
            />
          ),
          "Degrees Minutes Seconds": (
            <DegreesMinutesSeconds
              handleLatChange={handleLatChange}
              handleLonChange={handleLonChange}
              lat_long_format={values.lat_long_format}
              latitude_or_loran1={values.latitude_or_loran1}
              longitude_or_loran2={values.longitude_or_loran2}
            />
          ),
        }[values.lat_long_format]
      }
      <Box mt={5} width="100%" align="center" className="bottom-nav-container">
        <Grid container justifyContent="center" alignItems="center">
          <Grid item xs="auto" className="margRight20">
            <DefaultButton changeHandler={_cancel} buttonText={"Cancel"} />
          </Grid>
          <Grid item xs="auto">
            <DefaultButton changeHandler={_next} buttonText={"Save"} bgColor={success} />
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

export default connect(mapVtrStateToProps, mapDispatchToProps)(EffortPage3);
